import { TRefElementInstance } from 'widgets/toolbox/RefElement';
import { setCookie } from 'widgets/toolbox/cookie';

declare const window: ExtendedWindow;

function CoreGeolocationClassCreator(Geolocation: import('widgets/global/Geolocation').TGeolocation) {
    class CoreGeolocation extends Geolocation {
        init() {
            const geolocationDialog = window.sfccUnCachedData?.geolocationDialog;

            if (!geolocationDialog) {
                return;
            }

            setCookie(geolocationDialog.geolocationCookieName, '1', 360);
            this.renderDialog(geolocationDialog, true);
        }

        /**
         * Renders the geolocation dialog.
         *
         * @param geolocationDialog - The geolocation dialog object.
         * @param showDialog - Flag indicating whether to show the dialog.
         */
        renderDialog(geolocationDialog, showDialog) {
            this.render('template', geolocationDialog, this.ref('content')).then(() => {
                if (showDialog) {
                    const delayInSeconds = geolocationDialog.delayInSeconds ?? 0;

                    setTimeout(() => {
                        this.ref('self').attr('role', 'alert').show();
                    }, delayInSeconds * 1000);
                }
            });
        }

        /**
         * Updates the link based on the selected option.
         *
         * @param selectedOption - The selected option.
         */
        updateLink(selectedOption: TRefElementInstance) {
            const geolocationDialog = window.sfccUnCachedData?.geolocationDialog;

            if (!geolocationDialog) {
                return;
            }

            const localeID = selectedOption?.data<string>('locale');
            let locale;

            geolocationDialog?.redirectOptions.forEach((option, indx) => {
                if (option.default) {
                    geolocationDialog.redirectOptions[indx].default = false;
                }

                if (option.localeID === localeID) {
                    locale = option;
                    geolocationDialog.redirectOptions[indx].default = true;
                }
            });
            geolocationDialog.selectedLocaleUrl = locale?.redirectUrl;
            geolocationDialog.selectedLocale = locale?.selectedLocale;
            geolocationDialog.customerCountry = locale?.customerCountry;
            geolocationDialog.isRtl = locale?.isRtl;

            this.renderDialog(geolocationDialog, false);
        }
    }

    return CoreGeolocation;
}

export type TCoreGeolocation = ReturnType<typeof CoreGeolocationClassCreator>;

export type TCoreGeolocationInstance = InstanceType<TCoreGeolocation>;

export default CoreGeolocationClassCreator;
